import React from 'react';
import Header from './header';
import Footer from './footer';
import './layout.css';
import ProductComparisonBar from './product-comparison-bar';
import { CookieConsentScript } from '../scripts/cookie-consent-script';
import { GtmScript } from '../scripts/gtm-script';

const Layout = ({ location: { pathname }, children }) => {
  const isProduction = process.env['NODE_ENV'] === 'production';

  return (
    <div className="main">
      <Header />

      <div className="main-content">
        <main className="full-page">{children}</main>
        
        {!pathname?.startsWith('/porownywarka') && <ProductComparisonBar /> }
        {pathname === "/" ? <Footer homePage /> : <Footer /> }
      </div>

      {isProduction && <CookieConsentScript />}
      {isProduction && <GtmScript />}
    </div>
  );
}

export default Layout;
